var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-progress" }, [
    _c(
      "div",
      {
        staticClass: "upload-progress-header-container",
        class: { center: _vm.standalone && _vm.uploadComplete },
      },
      [
        _c(
          "div",
          { staticClass: "upload-progress-header" },
          [
            _c("span", { staticClass: "upload-progress-header-text" }, [
              _vm._v(_vm._s(_vm.headerText)),
            ]),
            !_vm.standalone
              ? _c(
                  "IconComponent",
                  {
                    staticClass: "upload-progress-close",
                    on: { click: _vm.onCloseClick },
                  },
                  [_vm._v("close")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    !(_vm.standalone && _vm.uploadComplete)
      ? _c(
          "div",
          { staticClass: "upload-progress-body" },
          [
            _vm.uploadComplete
              ? [
                  _c(
                    "div",
                    { staticClass: "upload-progress-photos" },
                    _vm._l(
                      _vm.photos.slice(Math.max(_vm.photos.length - 5, 0)),
                      function (photo, index) {
                        return _c("img", {
                          key: index,
                          staticClass: "upload-progress-photo",
                          class: ["thumb", index % 2 ? "bottom" : "top"],
                          attrs: { src: photo },
                        })
                      }
                    ),
                    0
                  ),
                  _c(
                    "ButtonComponent",
                    {
                      attrs: {
                        color: "primary",
                        width: "100%",
                        height: 40,
                        fontSize: 14,
                      },
                      on: { click: _vm.onStartEditingClick },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("views.uploadProgress.startEditingButton")
                        )
                      ),
                    ]
                  ),
                ]
              : [
                  _c("SpinnerComponent", {
                    staticClass: "upload-progress-spinner",
                    attrs: { size: 64 },
                  }),
                  _c("ProgressBar", {
                    attrs: {
                      progressPercentage: _vm.progressPercentage,
                      text: _vm.progressText,
                    },
                  }),
                ],
          ],
          2
        )
      : _vm._e(),
    _vm.standalone
      ? _c(
          "div",
          { staticClass: "upload-progress-footer" },
          [
            _c(
              "ButtonComponent",
              {
                attrs: {
                  color: "secondary",
                  width: 350,
                  height: 40,
                  fontSize: 16,
                },
                on: { click: _vm.onCancelClick },
              },
              [_vm._v(_vm._s(_vm.$t("views.uploadProgress.cancelButton")))]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }